import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, vShow as _vShow, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "bg-white" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = { class: "lg:grid lg:grid-cols-2 lg:gap-x-12 xl:gap-x-16" }
const _hoisted_4 = { class: "font-poppins" }
const _hoisted_5 = { class: "mt-4 grid grid-cols-1 gap-y-6 sm:grid-cols-2 gap-x-10 font-poppins" }
const _hoisted_6 = { class: "mt-1 flex" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "mt-1 flex" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "mt-4" }
const _hoisted_11 = { class: "mt-1 flex" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "sm:col-span-2 mt-4" }
const _hoisted_14 = { class: "mt-1 flex" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "mt-4 grid grid-cols-1 gap-y-6 sm:grid-cols-2 sm:gap-x-4" }
const _hoisted_17 = { class: "" }
const _hoisted_18 = { class: "mt-1" }
const _hoisted_19 = { class: "" }
const _hoisted_20 = { class: "mt-1 flex" }
const _hoisted_21 = ["min"]
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { class: "mt-6 flex space-x-2" }
const _hoisted_24 = { class: "flex items-center h-5" }
const _hoisted_25 = {
  key: 0,
  class: "mt-4 grid grid-cols-1 gap-y-6 sm:grid-cols-2 gap-x-10 font-poppins"
}
const _hoisted_26 = { class: "mt-1" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { class: "mt-1 flex" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { class: "mt-10 lg:mt-0" }
const _hoisted_31 = { class: "font-poppins" }
const _hoisted_32 = { class: "mt-4 bg-white" }
const _hoisted_33 = { class: "py-6 px-4 space-y-6 sm:px-6" }
const _hoisted_34 = { class: "" }
const _hoisted_35 = { class: "min-w-0 flex-1" }
const _hoisted_36 = { class: "text-lg py-0 my-0" }
const _hoisted_37 = { class: "text-base font-medium text-gray-900" }
const _hoisted_38 = { class: "text-md font-light pr-6" }
const _hoisted_39 = ["href"]
const _hoisted_40 = { class: "text-base font-medium text-gray-900" }
const _hoisted_41 = {
  key: 0,
  class: "text-red-400"
}
const _hoisted_42 = ["href"]
const _hoisted_43 = { class: "text-base font-medium text-gray-900" }
const _hoisted_44 = {
  key: 1,
  class: "flex items-center justify-between border-t border-gray-200 pt-6"
}
const _hoisted_45 = { class: "text-sm font-light h-64 overflow-hidden" }
const _hoisted_46 = { class: "text-md font-light pr-6" }
const _hoisted_47 = ["href"]
const _hoisted_48 = { class: "text-base font-medium text-gray-900" }
const _hoisted_49 = { class: "text-md font-light pr-6" }
const _hoisted_50 = ["href"]
const _hoisted_51 = { class: "text-base font-medium text-gray-900" }
const _hoisted_52 = { class: "grid grid-cols-1 md:grid-cols-3 z-50 relative pt-6" }
const _hoisted_53 = { class: "hidden md:block text-right col-span-1 col-start-3" }
const _hoisted_54 = { class: "lg:grid lg:grid-cols-2 lg:gap-x-12 xl:gap-x-16" }
const _hoisted_55 = { class: "border-t border-gray-200 pt-6" }
const _hoisted_56 = {
  key: 0,
  class: "mt-6 grid grid-cols-4 gap-y-6 gap-x-10 font-poppins"
}
const _hoisted_57 = { class: "col-span-4" }
const _hoisted_58 = { class: "mt-1 flex" }
const _hoisted_59 = { key: 0 }
const _hoisted_60 = { class: "col-span-4" }
const _hoisted_61 = { class: "mt-1 flex" }
const _hoisted_62 = { key: 0 }
const _hoisted_63 = { class: "col-span-3" }
const _hoisted_64 = { class: "mt-1 flex" }
const _hoisted_65 = { key: 0 }
const _hoisted_66 = { class: "mt-1 flex" }
const _hoisted_67 = { key: 0 }
const _hoisted_68 = {
  key: 1,
  class: "mt-6 grid grid-cols-4 gap-y-6 gap-x-4 font-poppins"
}
const _hoisted_69 = { class: "col-span-4" }
const _hoisted_70 = { class: "mt-1 flex" }
const _hoisted_71 = { key: 0 }
const _hoisted_72 = { class: "col-span-3" }
const _hoisted_73 = { class: "mt-1 flex" }
const _hoisted_74 = { key: 0 }
const _hoisted_75 = { class: "mt-1 flex" }
const _hoisted_76 = { key: 0 }
const _hoisted_77 = {
  key: 2,
  class: "col-span-4 pt-8 font-poppins"
}
const _hoisted_78 = { class: "mt-1 flex" }
const _hoisted_79 = ["max"]
const _hoisted_80 = { key: 0 }
const _hoisted_81 = {
  key: 3,
  class: "col-span-4 font-poppins pt-6"
}
const _hoisted_82 = { class: "mt-1 flex" }
const _hoisted_83 = { key: 0 }
const _hoisted_84 = { class: "mt-10 lg:mt-0" }
const _hoisted_85 = { class: "mt-4 bg-white font-poppins" }
const _hoisted_86 = {
  role: "list",
  class: "space-y-6"
}
const _hoisted_87 = { class: "" }
const _hoisted_88 = { class: "min-w-0 flex-1" }
const _hoisted_89 = { class: "text-md font-poppins-bold text-black my-0 py-0" }
const _hoisted_90 = { class: "" }
const _hoisted_91 = { class: "font-poppins-bold" }
const _hoisted_92 = { class: "font-poppins-bold" }
const _hoisted_93 = { class: "text-md mt-0 mb-2 py-0" }
const _hoisted_94 = { class: "text-xs font-bold text-md my-2 py-0.5 uppercase text-white bg-black w-full px-6 rounded-full tracking-widest" }
const _hoisted_95 = { class: "ml-6 flex-1 flex flex-col" }
const _hoisted_96 = { class: "flex-1 flex flex-row-reverse items-start justify-between" }
const _hoisted_97 = { class: "flex items-end justify-end" }
const _hoisted_98 = {
  key: 0,
  class: "text-md my-0 py-0"
}
const _hoisted_99 = { class: "flex-1 flex flex-row-reverse items-start" }
const _hoisted_100 = {
  key: 0,
  class: "text-sm font-medium text-gray-900"
}
const _hoisted_101 = { class: "" }
const _hoisted_102 = { class: "ml-6 flex-1 flex flex-col" }
const _hoisted_103 = { class: "flex-1 flex flex-row-reverse items-start justify-between" }
const _hoisted_104 = { class: "flex-1 flex flex-row-reverse items-start" }
const _hoisted_105 = {
  key: 0,
  class: "my-0 py-0 font-poppins-bold"
}
const _hoisted_106 = { class: "text-md font-poppins-bold pb-4" }
const _hoisted_107 = { class: "tooltip" }
const _hoisted_108 = { class: "ml-6 flex-1 flex flex-col pb-4" }
const _hoisted_109 = { class: "flex-1 flex flex-row-reverse items-start justify-between" }
const _hoisted_110 = { class: "flex-1 flex flex-row-reverse items-start" }
const _hoisted_111 = {
  key: 0,
  class: "my-0 py-0 font-poppins-bold"
}
const _hoisted_112 = { class: "flex flex-col items-start my-6 justify-between py-6 px-4 sm:px-6 border rounded-lg border-solid border-black text-black" }
const _hoisted_113 = { class: "flex flex-col w-full" }
const _hoisted_114 = { class: "flex flex-row pt-4 justify-between" }
const _hoisted_115 = {
  key: 0,
  class: "mt-1 font-normal text-sm text-green-500"
}
const _hoisted_116 = {
  key: 1,
  class: "mt-1 font-normal text-sm text-red-500"
}
const _hoisted_117 = {
  key: 0,
  class: "flex items-left justify-start py-4 px-4 sm:px-6 border rounded-lg border-solid border-black text-black flex-col"
}
const _hoisted_118 = {
  key: 0,
  class: "flex items-center justify-between border-t border-gray-200 py-1 px-4 sm:px-6"
}
const _hoisted_119 = {
  key: 1,
  class: "flex items-center justify-between border-t border-gray-200 py-1 px-4 sm:px-6"
}
const _hoisted_120 = {
  key: 2,
  class: "flex items-center justify-between border-t border-gray-200 py-1 px-4 sm:px-6"
}
const _hoisted_121 = {
  key: 3,
  class: "flex items-center justify-between border-t border-gray-200 py-1 px-4 sm:px-6"
}
const _hoisted_122 = { class: "flex flex-row items-start my-6 justify-between py-6 px-4 sm:px-6 border rounded-lg border-solid border-black text-black" }
const _hoisted_123 = { class: "text-md font-poppins-bold" }
const _hoisted_124 = { class: "text-md font-poppins pt-6 max-w-md" }
const _hoisted_125 = { class: "font-poppins-bold" }
const _hoisted_126 = { class: "text-md font-poppins-bold" }
const _hoisted_127 = { class: "py-6 flex flex-col md:flex-row items-end justify-end" }
const _hoisted_128 = { class: "w-full" }
const _hoisted_129 = {
  key: 0,
  class: "mt-4 text-sm text-red-600"
}
const _hoisted_130 = {
  key: 1,
  class: "mt-4 text-sm text-red-600"
}

import { computed, reactive, ref, watch } from 'vue';
import { useVuelidate } from '@vuelidate/core';
import { helpers, email, required, requiredIf, minLength, maxLength, integer } from '@vuelidate/validators';
import { ccValidations } from '@/validations/ccValidations';
import { nameValidations } from '@/validations/nameValidations';
import { OrderServiceInterface } from '@/services/orderServiceInterface';
import { injectStrict } from '@/plugins/vueServiceContainerPlugin';
import { Product } from '@/adapters/catalogAdapterInterface';
import { UtilityServiceInterface } from '@/services/utilityServiceInterface';
import AsyncButton from '../library/AsyncButton.vue';
import { BrandServiceInterface } from '@/services/brand/brandServiceInterface';
import format from 'date-fns/format';
import addDays from 'date-fns/fp/addDays';
import store from '@/store';
import { InformationCircleIcon } from '@heroicons/vue/outline';
import { RecaptchaV2, useRecaptcha } from 'vue3-recaptcha-v2';

// Adding this prevents Vue warnings
import { Switch } from '@headlessui/vue';
import { Action, Promotion } from '@uniti-internet/promotions-js-client/dist/utilities/types';
import CsgTerms from '@/components/content/CsgTerms.vue';
import StepGuide from './StepGuide.vue';

export type ContactInformation = {
  firstName: string | null,
  lastName: string | null,
  phoneNumber: string | null,
  email: string
};

type Service = {
  id: string,
  address: string,
  carrier: string,
  locationId: string,
  requiresNewDevelopmentCost: boolean,
  development: string,
  suburb: string,
  state: string,
  rtcDays: number,
}

type ConfirmOrderData = {
  firstName: string,
  lastName: string,
  email: string,
  phoneNumber: number | null,
  companyName: string,
  abnNumber: number | null,
  ccNumber: number | null,
  ccName: string,
  ccExpiry: string,
  ccCvc: string,
  ddAccountName: string,
  ddAccountNumber: string,
  ddAccountBsb: string,
  token?: string,
  activationDate: string,
  formSelectionOptions: {
    businessAccount: boolean,
    paymentMethod: string,
    confirmAddressToggle: boolean,
    termsAgreementToggle: boolean,
    privacyToggle: boolean,
    csgWaiverToggle: boolean,
    toggleExpandCsgWaiver: boolean,
    ddAgreementToggle: boolean,
    pickActivationDate: boolean
  },
  captchaValid: boolean,
  birthdate?: string | null,
  licenseId?: string | null
}


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderForm',
  props: {
    errors: {},
    products: {},
    service: {},
    isPromoValid: { type: Boolean },
    promotionDiscounts: {},
    validPromotion: {},
    suggestedPromotion: {}
  },
  emits: ["onEnterPromoCode", "onConfirmOrder", "onContactInformation"],
  setup(__props: any, { emit: __emit }) {

const orderService = injectStrict<OrderServiceInterface>('OrderServiceInterface');
const utilityService = injectStrict<UtilityServiceInterface>('UtilityServiceInterface');
const brandService = injectStrict<BrandServiceInterface>('BrandServiceInterface');

const props = __props;

const delayedNdc = computed(() => {
  return props.promotionDiscounts.find(discount => discount.actionCatalogObject.code === 'DELAYED-NDC');
});

const yearOff = computed(() => {
  return props.promotionDiscounts.find(discount => discount.actionCatalogObject.code === 'YEAR-OFF');
});

const monthOff = computed(() => {
  let plan = '';
  if (props.products.length > 0 && props.products.filter(pr => pr.type === 'internet').length > 0) {
    plan = props.products.filter(pr => pr.type === 'internet')[0].id;
  }
  return props.promotionDiscounts.find(discount => discount.actionCatalogObject.code === 'ONE-OFF' && (discount.applicableTo.length <= 0 || (discount.applicableTo.length > 0 && discount.applicableTo.includes(plan))));
});

const preInstalledRouter = computed(() => {
  return props.promotionDiscounts.find(discount => discount.actionCatalogObject.code === 'FREE-ROUTER-INSTALLED');
});

const account = computed(() => {
  return store.state.account;
});

const salesPerson = computed(() => {
  return store.state.salesPerson;
});

const isPromoValid = computed(() => {
  return props.isPromoValid;
});

const voiceProduct = computed(() => {
  return props.products.filter(product => product.type === 'voice').length > 0;
});

const today = computed((): string => {
  return format(new Date(), 'yyyy-MM-dd');
});

const tomorrow = computed((): string => {
  return format(addDays(1, new Date()), 'yyyy-MM-dd');
});

const min18 = computed((): string => {
  const td = new Date();
  return format(td.setFullYear(td.getFullYear() - 18), 'yyyy-MM-dd');
});

const formData : ConfirmOrderData = reactive({
  firstName: '',
  lastName: '',
  email: '',
  phoneNumber: null,
  companyName: '',
  abnNumber: null,
  ccNumber: null,
  ccName: '',
  ccExpiry: '',
  ccCvc: '',
  ddAccountName: '',
  ddAccountNumber: '',
  ddAccountBsb: '',
  token: '',
  crmId: null,
  activationDate: today.value,
  formSelectionOptions: {
    businessAccount: false,
    paymentMethod: 'cc',
    confirmAddressToggle: false,
    termsAgreementToggle: false,
    privacyToggle: false,
    csgWaiverToggle: false,
    toggleExpandCsgWaiver: false,
    ddAgreementToggle: false,
    pickActivationDate: false
  },
  captchaValid: false,
  birthdate: '',
  licenseId: ''
});

const { handleReset } = useRecaptcha();

const handleWidgetId = (widgetId: number) => {
  handleReset(widgetId);
};
const handleErrorCalback = () => {
  formData.captchaValid = false;
};
const handleExpiredCallback = () => {
  formData.captchaValid = false;
};
const handleLoadCallback = (response: unknown) => {
  if (response) {
    formData.captchaValid = true;
  }
};

const promoCode = ref(props.suggestedPromotion?.code);

function promoCodeClickHandler () {
  let promoCodeUppercase;
  if (promoCode.value) {
    promoCodeUppercase = promoCode.value.toUpperCase();
  }
  emit('onEnterPromoCode', promoCodeUppercase);
}

const contactInformation : ContactInformation = reactive({
  firstName: null,
  lastName: null,
  phoneNumber: null,
  email: ''
});

const pickActivationDate = ref(() => formData.formSelectionOptions.pickActivationDate);
const businessAccount = ref(() => formData.formSelectionOptions.businessAccount);
const paymentMethodRequiredCc = ref(() => formData.formSelectionOptions.paymentMethod === 'cc' && (!salesPerson.value));
const paymentMethodRequiredDd = ref(() => formData.formSelectionOptions.paymentMethod === 'dd' && (!salesPerson.value));
const bdayRequired = ref(() => orderService.calculateMinimumCost(props.products, props.isPromoValid, props.validPromotion) >= 1000);

const rules = {
  firstName: {
    required: helpers.withMessage('Please enter a firstname', required),
    nameValidation: helpers.withMessage('Please enter letters only', nameValidations.nameValidation),
    maxLengthValue: helpers.withMessage('Please enter less than 20 chars', maxLength(20))
  },
  lastName: {
    required: helpers.withMessage('Please enter a lastname', required),
    nameValidation: helpers.withMessage('Please enter letters only', nameValidations.nameValidation),
    maxLengthValue: helpers.withMessage('Please enter less than 20 chars', maxLength(20))
  },
  email: {
    required: helpers.withMessage('Please enter an email address', required),
    email: helpers.withMessage('Please enter a valid email address', email)
  },
  phoneNumber: {
    required: helpers.withMessage('This field cannot be empty', required),
    integer: helpers.withMessage('Please enter numbers only', integer),
    minLength: helpers.withMessage('Please enter a phone number with 10 digits', minLength(10)),
    maxLengthValue: helpers.withMessage('Please enter a phone number with 10 digits', maxLength(10))
  },
  companyName: {
    requiredIf: helpers.withMessage('Please enter a company name', requiredIf(businessAccount.value)),
    minLength: helpers.withMessage('Please enter a phone number with 10 digits', minLength(1)),
    maxLengthValue: helpers.withMessage('Please enter less than 50 chars', maxLength(50)),
    nameValidation: helpers.withMessage('Please enter letters only', nameValidations.nameValidation)
  },
  abnNumber: {
    requiredIf: helpers.withMessage('Please enter an ABN number', requiredIf(businessAccount.value)),
    integer: helpers.withMessage('Please enter numbers only', integer),
    minLength: helpers.withMessage('Please enter a 11 digit ABN number', minLength(11)),
    maxLength: helpers.withMessage('Please enter a 11 digit ABN number', maxLength(11))
  },
  ccNumber: {
    requiredIf: helpers.withMessage('Please enter a credit card number', requiredIf(paymentMethodRequiredCc.value)),
    integer: helpers.withMessage('Please enter numbers only', integer),
    ccValidation: helpers.withMessage('Please enter a valid credit card number', ccValidations.numberValidation)
  },
  ccName: {
    requiredIf: helpers.withMessage('Please enter a credit card number', requiredIf(paymentMethodRequiredCc.value)),
    maxLengthValue: helpers.withMessage('Please enter less than 20 chars', maxLength(40))
  },
  ccExpiry: {
    requiredIf: helpers.withMessage('Please enter a credit card number', requiredIf(paymentMethodRequiredCc.value)),
    ccExpiryValidation: helpers.withMessage('Please enter a valid MM/YY expiry', ccValidations.expiryValidation)
  },
  ccCvc: {
    requiredIf: helpers.withMessage('Please enter a credit card number', requiredIf(paymentMethodRequiredCc.value)),
    ccCvcValidation: helpers.withMessage('Please enter a valid CVC number', ccValidations.cvcValidation)
  },
  ddAccountName: {
    requiredIf: helpers.withMessage('Please enter an account name', requiredIf(paymentMethodRequiredDd.value)),
    minLength: helpers.withMessage('Please enter a valid account name', minLength(2))
  },
  ddAccountNumber: {
    requiredIf: helpers.withMessage('Please enter an account number', requiredIf(paymentMethodRequiredDd.value)),
    integer: helpers.withMessage('Please enter numbers only', integer),
    minLength: helpers.withMessage('Please enter a valid account number', minLength(6)),
    maxLength: helpers.withMessage('Please enter a valid account number', maxLength(10))
  },
  ddAccountBsb: {
    requiredIf: helpers.withMessage('Please enter a BSB number', requiredIf(paymentMethodRequiredDd.value)),
    integer: helpers.withMessage('Please enter numbers only', integer),
    minLength: helpers.withMessage('Please enter a 6 digit BSB number', minLength(6)),
    maxLength: helpers.withMessage('Please enter a 6 digit BSB number', maxLength(6))
  },
  activationDate: {
    requiredIf: helpers.withMessage('Please select a date the service should be activated', requiredIf(pickActivationDate.value))
  },
  birthdate: {
    requiredIf: helpers.withMessage('Please enter your birthdate', requiredIf(bdayRequired.value))
  }
};
const v$ = useVuelidate(rules, formData);

const directDebitFormFields = computed(() => {
  return formData.formSelectionOptions.paymentMethod !== 'cc';
});

// eslint-disable-next-line func-call-spacing
const emit = __emit;

const confirmAddressError = ref(false);
const termsAgreementError = ref(false);
const ddAgreementError = ref(false);
const privacyError = ref(false);
const csgWaiverError = ref(false);
const captchaError = ref(false);

const handleConfirmOrder = async (done: () => void) => {
  const formValidated = await v$.value.$validate();

  if (!formData.formSelectionOptions.confirmAddressToggle) confirmAddressError.value = true;
  if (!formData.formSelectionOptions.termsAgreementToggle) termsAgreementError.value = true;
  if (!formData.formSelectionOptions.ddAgreementToggle) ddAgreementError.value = true;
  if (!formData.formSelectionOptions.privacyToggle) privacyError.value = true;
  if (voiceProduct.value && !formData.formSelectionOptions.csgWaiverToggle) csgWaiverError.value = true;

  if (!voiceProduct.value) {
    if (formValidated && !confirmAddressError.value && !termsAgreementError.value && !ddAgreementError.value && !privacyError.value) {
      emit('onConfirmOrder', formData, done);
    } else {
      done();
    }
  } else if (voiceProduct.value) {
    if (formValidated && voiceProduct.value && !confirmAddressError.value && !termsAgreementError.value && !ddAgreementError.value && !csgWaiverError.value && !privacyError.value) {
      emit('onConfirmOrder', formData, done);
    } else {
      done();
    }
  }
};

const handleClickConfirmAddress = () => {
  if (formData.formSelectionOptions.confirmAddressToggle) confirmAddressError.value = false;
};

const handleClickTermsAgreement = () => {
  if (formData.formSelectionOptions.termsAgreementToggle) termsAgreementError.value = false;
};

const handleClickCsgWaiver = () => {
  if (formData.formSelectionOptions.csgWaiverToggle) csgWaiverError.value = false;
};

const handleClickDdAgreement = () => {
  if (formData.formSelectionOptions.ddAgreementToggle) ddAgreementError.value = false;
};

const handleClickPrivacyAgreement = () => {
  if (formData.formSelectionOptions.privacyToggle) privacyError.value = false;
};

const handleClickBusinessAccount = () => {
  formData.companyName = '';
  formData.abnNumber = null;
};

const handleActivationDate = () => {
  if (formData.formSelectionOptions.pickActivationDate) {
    formData.activationDate = tomorrow.value;
  } else {
    formData.activationDate = today.value;
  }
};

const handleFirstNameBlur = () => {
  v$.value.firstName.$touch();

  if (!v$.value.firstName.$error) {
    contactInformation.firstName = formData.firstName;
  } else {
    contactInformation.firstName = null;
  }
};

const handleLastNameBlur = () => {
  v$.value.lastName.$touch();

  if (!v$.value.lastName.$error) {
    contactInformation.lastName = formData.lastName;
  } else {
    contactInformation.lastName = null;
  }
};

const handlePhoneBlur = () => {
  v$.value.phoneNumber.$touch();

  if (!v$.value.phoneNumber.$error) {
    contactInformation.phoneNumber = formData.phoneNumber;
  } else {
    contactInformation.phoneNumber = null;
  }
};

const handleEmailBlur = () => {
  v$.value.email.$touch();

  if (!v$.value.email.$error) {
    contactInformation.email = formData.email;
  } else {
    contactInformation.email = null;
  }
};

const toggleExpandCsgWaiver = () => {
  formData.formSelectionOptions.toggleExpandCsgWaiver = !formData.formSelectionOptions.toggleExpandCsgWaiver;
};

watch(
  contactInformation,
  (newContactInformation) => {
    if (newContactInformation.email) {
      emit('onContactInformation', newContactInformation);
    }
  }
);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[91] || (_cache[91] = _createElementVNode("h2", { class: "sr-only" }, "Checkout", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_4, [
            _cache[48] || (_cache[48] = _createElementVNode("h2", { class: "text-2xl font-poppins-bold text-black" }, "Contact information", -1)),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", null, [
                _cache[38] || (_cache[38] = _createElementVNode("label", {
                  for: "first-name",
                  class: "block text-sm font-bold text-black"
                }, "First name", -1)),
                _createElementVNode("div", _hoisted_6, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "first-name",
                    name: "first-name",
                    autocomplete: "given-name",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.firstName) = $event)),
                    onBlur: handleFirstNameBlur,
                    class: "block w-full rounded-full shadow-sm sm:text-sm bg-gray-200 border-none"
                  }, null, 544), [
                    [_vModelText, formData.firstName]
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).$errors, (error) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: error.$uid,
                    class: "mt-2 text-sm text-red-600",
                    id: "firstName-error"
                  }, [
                    (error.$property === 'firstName')
                      ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(error.$message), 1))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", null, [
                _cache[39] || (_cache[39] = _createElementVNode("label", {
                  for: "last-name",
                  class: "block text-sm font-bold text-black"
                }, "Last name", -1)),
                _createElementVNode("div", _hoisted_8, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "last-name",
                    name: "last-name",
                    autocomplete: "family-name",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.lastName) = $event)),
                    onBlur: handleLastNameBlur,
                    class: "block w-full rounded-full shadow-sm sm:text-sm bg-gray-200 border-none"
                  }, null, 544), [
                    [_vModelText, formData.lastName]
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).$errors, (error) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: error.$uid,
                    class: "mt-2 text-sm text-red-600",
                    id: "lastName-error"
                  }, [
                    (error.$property === 'lastName')
                      ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(error.$message), 1))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _cache[40] || (_cache[40] = _createElementVNode("label", {
                for: "email-address",
                class: "block text-sm font-bold text-black"
              }, "Email address", -1)),
              _createElementVNode("div", _hoisted_11, [
                _withDirectives(_createElementVNode("input", {
                  type: "email",
                  id: "email-address",
                  name: "email-address",
                  autocomplete: "email",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.email) = $event)),
                  onBlur: handleEmailBlur,
                  class: "block w-full rounded-full shadow-sm sm:text-sm bg-gray-200 border-none"
                }, null, 544), [
                  [_vModelText, formData.email]
                ])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).$errors, (error) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: error.$uid,
                  class: "mt-2 text-sm text-red-600",
                  id: "email-error"
                }, [
                  (error.$property === 'email')
                    ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(error.$message), 1))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_13, [
              _cache[41] || (_cache[41] = _createElementVNode("label", {
                for: "phone",
                class: "block text-sm font-bold text-black"
              }, "Phone", -1)),
              _createElementVNode("div", _hoisted_14, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  name: "phone",
                  id: "phone",
                  autocomplete: "tel",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.phoneNumber) = $event)),
                  onBlur: handlePhoneBlur,
                  class: "block w-full rounded-full shadow-sm sm:text-sm bg-gray-200 border-none"
                }, null, 544), [
                  [_vModelText, formData.phoneNumber]
                ])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).$errors, (error) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: error.$uid,
                  class: "mt-2 text-sm text-red-600",
                  id: "phoneNumber-error"
                }, [
                  (error.$property === 'phoneNumber')
                    ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(error.$message), 1))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _cache[43] || (_cache[43] = _createElementVNode("label", {
                  for: "activationDateOption",
                  class: "block text-sm font-bold text-black"
                }, "Service activation date", -1)),
                _createElementVNode("div", _hoisted_18, [
                  _withDirectives(_createElementVNode("select", {
                    id: "activationDateOption",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.formSelectionOptions.pickActivationDate) = $event)),
                    class: "block w-full rounded-full shadow-sm sm:text-sm bg-gray-200 border-none",
                    onChange: handleActivationDate
                  }, _cache[42] || (_cache[42] = [
                    _createElementVNode("option", { value: false }, "ASAP", -1),
                    _createElementVNode("option", { value: true }, "Pick a Date", -1)
                  ]), 544), [
                    [_vModelSelect, formData.formSelectionOptions.pickActivationDate]
                  ])
                ])
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_19, [
                _cache[44] || (_cache[44] = _createElementVNode("label", {
                  for: "activationDate",
                  class: "block text-sm font-bold text-black"
                }, "Confirm service activation date", -1)),
                _createElementVNode("div", _hoisted_20, [
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    min: tomorrow.value,
                    name: "activationDate",
                    id: "activationDate",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.activationDate) = $event)),
                    onBlur: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_unref(v$).activationDate.$touch && _unref(v$).activationDate.$touch(...args))),
                    class: "block w-full rounded-full shadow-sm sm:text-sm bg-gray-200 border-none"
                  }, null, 40, _hoisted_21), [
                    [_vModelText, formData.activationDate]
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).$errors, (error) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: error.$uid,
                    class: "mt-2 text-sm text-red-600",
                    id: "activationDate-error"
                  }, [
                    (error.$property === 'activationDate')
                      ? (_openBlock(), _createElementBlock("p", _hoisted_22, _toDisplayString(error.$message), 1))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ], 512), [
                [_vShow, formData.formSelectionOptions.pickActivationDate]
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _withDirectives(_createElementVNode("input", {
                  onClick: handleClickBusinessAccount,
                  id: "same-as-shipping",
                  name: "same-as-shipping",
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.formSelectionOptions.businessAccount) = $event)),
                  class: "h-4 w-4 border-black border-solid border-1 rounded text-black focus:ring-brand-primary"
                }, null, 512), [
                  [_vModelCheckbox, formData.formSelectionOptions.businessAccount]
                ])
              ]),
              _cache[45] || (_cache[45] = _createElementVNode("label", {
                for: "same-as-shipping",
                class: "text-sm font-bold text-gray-900"
              }, "Is this a business account?", -1))
            ]),
            (formData.formSelectionOptions.businessAccount)
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                  _createElementVNode("div", null, [
                    _cache[46] || (_cache[46] = _createElementVNode("label", {
                      for: "company-name",
                      class: "block text-sm font-bold text-black"
                    }, "Company name", -1)),
                    _createElementVNode("div", _hoisted_26, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        id: "company-name",
                        name: "company-name",
                        autocomplete: "organization",
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.companyName) = $event)),
                        onBlur: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_unref(v$).companyName.$touch && _unref(v$).companyName.$touch(...args))),
                        class: "block w-full rounded-full shadow-sm sm:text-sm bg-gray-200 border-none"
                      }, null, 544), [
                        [_vModelText, formData.companyName]
                      ])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).$errors, (error) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: error.$uid,
                        class: "mt-2 text-sm text-red-600",
                        id: "companyName-error"
                      }, [
                        (error.$property === 'companyName')
                          ? (_openBlock(), _createElementBlock("p", _hoisted_27, _toDisplayString(error.$message), 1))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("div", null, [
                    _cache[47] || (_cache[47] = _createElementVNode("label", {
                      for: "abn-number",
                      class: "block text-sm font-bold text-black"
                    }, "ABN Number", -1)),
                    _createElementVNode("div", _hoisted_28, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        id: "abn-number",
                        name: "abn-number",
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formData.abnNumber) = $event)),
                        onBlur: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_unref(v$).abnNumber.$touch && _unref(v$).abnNumber.$touch(...args))),
                        class: "block w-full rounded-full shadow-sm sm:text-sm bg-gray-200 border-none"
                      }, null, 544), [
                        [_vModelText, formData.abnNumber]
                      ])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).$errors, (error) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: error.$uid,
                        class: "mt-2 text-sm text-red-600",
                        id: "abnNumber-error"
                      }, [
                        (error.$property === 'abnNumber')
                          ? (_openBlock(), _createElementBlock("p", _hoisted_29, _toDisplayString(error.$message), 1))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_30, [
          _cache[60] || (_cache[60] = _createElementVNode("h2", { class: "text-2xl font-poppins-bold text-black" }, "Confirm Details", -1)),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", {
                  class: _normalizeClass(["flex transition duration-200 justify-between items-center rounded-lg py-6 px-6", [formData.formSelectionOptions.confirmAddressToggle ? 'bg-gradient-to-tr from-brand-primary-light to-brand-primary-dark text-white' : 'border-solid border-black border text-black']])
                }, [
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                      _cache[49] || (_cache[49] = _createElementVNode("p", { class: "text-2xl font-light py-0 my-0" }, " My address is: ", -1)),
                      _createElementVNode("p", _hoisted_36, _toDisplayString(_ctx.service.address), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_37, [
                    _createVNode(_unref(Switch), {
                      onClick: handleClickConfirmAddress,
                      modelValue: formData.formSelectionOptions.confirmAddressToggle,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formData.formSelectionOptions.confirmAddressToggle) = $event)),
                      class: _normalizeClass([
                        (formData.formSelectionOptions.confirmAddressToggle ? 'bg-white' : 'bg-gray-300'),
                        ('relative inline-flex flex-shrink-0 h-6 w-11 border-1 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 my-0 py-0'),
                        (confirmAddressError.value ? 'ring-1 ring-offset-1 ring-brand-primary' : 'focus:outline-none focus:ring-1 focus:ring-offset-1 focus:ring-brand-primary')
                        ])
                    }, {
                      default: _withCtx(() => [
                        _cache[50] || (_cache[50] = _createElementVNode("span", { class: "sr-only" }, "Use setting", -1)),
                        _createElementVNode("div", {
                          class: _normalizeClass([formData.formSelectionOptions.confirmAddressToggle ? 'translate-x-4 bg-brand-primary' : 'translate-x-0 bg-white', 'pointer-events-none relative inline-block h-5 w-5 rounded-full  shadow transform ring-0 transition ease-in-out duration-200 -ml-1'])
                        }, [
                          _createElementVNode("div", {
                            class: _normalizeClass([formData.formSelectionOptions.confirmAddressToggle ? 'opacity-0 ease-out duration-100' : 'opacity-100 ease-in duration-200', 'absolute inset-0 h-full w-full flex items-center justify-center transition']),
                            "aria-hidden": "true"
                          }, null, 2),
                          _createElementVNode("div", {
                            class: _normalizeClass([formData.formSelectionOptions.confirmAddressToggle ? 'opacity-100 ease-in duration-200' : 'opacity-0 ease-out duration-100', 'absolute inset-0 h-full w-full flex items-center justify-center transition']),
                            "aria-hidden": "true"
                          }, null, 2)
                        ], 2)
                      ]),
                      _: 1,
                      __: [50]
                    }, 8, ["modelValue", "class"])
                  ])
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["flex transition duration-200 justify-between items-center rounded-lg py-6 px-2 md:px-6", [formData.formSelectionOptions.termsAgreementToggle ? 'bg-gradient-to-tr from-brand-primary-light to-brand-primary-dark text-white' : 'border-solid border-black border text-black']])
                }, [
                  _createElementVNode("div", _hoisted_38, [
                    _cache[51] || (_cache[51] = _createTextVNode(" I have read, understood and accept the ")),
                    _createElementVNode("a", {
                      href: `https://uniti-bpo-website-assets.assets.unitiinternet.com/${_unref(brandService).getName()}/customer-service-agreement.pdf`,
                      target: "_blank",
                      class: _normalizeClass(["hover:underline transition duration-250 font-bold", [formData.formSelectionOptions.termsAgreementToggle ? 'text-white' : 'text-black']])
                    }, "Terms and Conditions.", 10, _hoisted_39)
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    _createVNode(_unref(Switch), {
                      onClick: handleClickTermsAgreement,
                      modelValue: formData.formSelectionOptions.termsAgreementToggle,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((formData.formSelectionOptions.termsAgreementToggle) = $event)),
                      class: _normalizeClass([
                        (formData.formSelectionOptions.termsAgreementToggle ? 'bg-white' : 'bg-gray-300'),
                        ('relative inline-flex flex-shrink-0 h-6 w-11 border-1 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 my-0 py-0'),
                        (termsAgreementError.value ? 'ring-1 ring-offset-1 ring-brand-primary' : 'focus:outline-none focus:ring-1 focus:ring-offset-1 focus:ring-brand-primary')
                        ])
                    }, {
                      default: _withCtx(() => [
                        _cache[52] || (_cache[52] = _createElementVNode("span", { class: "sr-only" }, "Use setting", -1)),
                        _createElementVNode("div", {
                          class: _normalizeClass([formData.formSelectionOptions.termsAgreementToggle ? 'translate-x-4 bg-brand-primary' : 'translate-x-0 bg-white', 'pointer-events-none relative inline-block h-5 w-5 rounded-full  shadow transform ring-0 transition ease-in-out duration-200 -ml-1'])
                        }, [
                          _createElementVNode("div", {
                            class: _normalizeClass([formData.formSelectionOptions.termsAgreementToggle ? 'opacity-0 ease-out duration-100' : 'opacity-100 ease-in duration-200', 'absolute inset-0 h-full w-full flex items-center justify-center transition']),
                            "aria-hidden": "true"
                          }, null, 2),
                          _createElementVNode("div", {
                            class: _normalizeClass([formData.formSelectionOptions.termsAgreementToggle ? 'opacity-100 ease-in duration-200' : 'opacity-0 ease-out duration-100', 'absolute inset-0 h-full w-full flex items-center justify-center transition']),
                            "aria-hidden": "true"
                          }, null, 2)
                        ], 2)
                      ]),
                      _: 1,
                      __: [52]
                    }, 8, ["modelValue", "class"])
                  ])
                ], 2),
                (voiceProduct.value)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(["flex transition duration-200 justify-between items-center rounded-lg py-6 px-2 md:px-6", [formData.formSelectionOptions.csgWaiverToggle ? 'bg-gradient-to-tr from-brand-primary-light to-brand-primary-dark text-white' : 'border-solid border-black border text-black']])
                    }, [
                      _createElementVNode("div", {
                        class: "text-md font-light",
                        onClick: _cache[14] || (_cache[14] = ($event: any) => (toggleExpandCsgWaiver()))
                      }, [
                        _cache[54] || (_cache[54] = _createTextVNode(" I have read, understood and accept the ")),
                        _createElementVNode("span", {
                          class: _normalizeClass(["underline transition duration-250 font-bold", [formData.formSelectionOptions.csgWaiverToggle ? 'text-white' : 'text-black']])
                        }, "CSG waiver.", 2),
                        (formData.formSelectionOptions.csgWaiverToggle && salesPerson.value)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_41, [
                              _cache[53] || (_cache[53] = _createTextVNode("Ensure you have read the ")),
                              _createElementVNode("a", {
                                class: "text-red-600",
                                href: _ctx.$router.resolve({ name: 'csg-waiver-script' }).href,
                                target: "_blank"
                              }, "CSG Waiver Script", 8, _hoisted_42)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_43, [
                        _createVNode(_unref(Switch), {
                          onClick: handleClickCsgWaiver,
                          modelValue: formData.formSelectionOptions.csgWaiverToggle,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((formData.formSelectionOptions.csgWaiverToggle) = $event)),
                          class: _normalizeClass([
                        (formData.formSelectionOptions.csgWaiverToggle ?  'bg-white' : 'bg-gray-300'),
                        ('relative inline-flex flex-shrink-0 h-6 w-11 border-1 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 my-0 py-0'),
                        (csgWaiverError.value ? 'ring-1 ring-offset-1 ring-brand-primary' : 'focus:outline-none focus:ring-1 focus:ring-offset-1 focus:ring-brand-primary')
                        ])
                        }, {
                          default: _withCtx(() => [
                            _cache[55] || (_cache[55] = _createElementVNode("span", { class: "sr-only" }, "Use setting", -1)),
                            _createElementVNode("div", {
                              class: _normalizeClass([formData.formSelectionOptions.csgWaiverToggle ? 'translate-x-4 bg-brand-primary' : 'translate-x-0 bg-white', 'pointer-events-none relative inline-block h-5 w-5 rounded-full  shadow transform ring-0 transition ease-in-out duration-200 -ml-1'])
                            }, [
                              _createElementVNode("div", {
                                class: _normalizeClass([formData.formSelectionOptions.csgWaiverToggle ? 'opacity-0 ease-out duration-100' : 'opacity-100 ease-in duration-200', 'absolute inset-0 h-full w-full flex items-center justify-center transition']),
                                "aria-hidden": "true"
                              }, null, 2),
                              _createElementVNode("div", {
                                class: _normalizeClass([formData.formSelectionOptions.csgWaiverToggle ? 'opacity-100 ease-in duration-200' : 'opacity-0 ease-out duration-100', 'absolute inset-0 h-full w-full flex items-center justify-center transition']),
                                "aria-hidden": "true"
                              }, null, 2)
                            ], 2)
                          ]),
                          _: 1,
                          __: [55]
                        }, 8, ["modelValue", "class"])
                      ])
                    ], 2))
                  : _createCommentVNode("", true),
                (voiceProduct.value && formData.formSelectionOptions.toggleExpandCsgWaiver)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                      _createElementVNode("div", _hoisted_45, [
                        _createVNode(CsgTerms, {
                          firstName: contactInformation.firstName,
                          lastName: contactInformation.lastName,
                          brand: _unref(brandService).getTitle(),
                          phone: _unref(brandService).getSupportPhoneNumber(),
                          address: _unref(brandService).getAddress()
                        }, null, 8, ["firstName", "lastName", "brand", "phone", "address"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: _normalizeClass(["flex transition duration-200 justify-between items-center rounded-lg py-6 px-2 md:px-6", [formData.formSelectionOptions.ddAgreementToggle ? 'bg-gradient-to-tr from-brand-primary-light to-brand-primary-dark text-white' : 'border-solid border-black border text-black']])
                }, [
                  _createElementVNode("div", _hoisted_46, [
                    _cache[56] || (_cache[56] = _createTextVNode(" I have read, understood and accept the ")),
                    _createElementVNode("a", {
                      href: `https://uniti-bpo-website-assets.assets.unitiinternet.com/${_unref(brandService).getName()}/direct-debit-service-request-agreement.pdf`,
                      target: "_blank",
                      class: _normalizeClass(["underline transition duration-250 font-bold", [formData.formSelectionOptions.ddAgreementToggle ? 'text-white' : 'text-black']])
                    }, "Direct Debit Service Request Agreement.", 10, _hoisted_47)
                  ]),
                  _createElementVNode("div", _hoisted_48, [
                    _createVNode(_unref(Switch), {
                      onClick: handleClickDdAgreement,
                      modelValue: formData.formSelectionOptions.ddAgreementToggle,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((formData.formSelectionOptions.ddAgreementToggle) = $event)),
                      class: _normalizeClass([
                        (formData.formSelectionOptions.ddAgreementToggle ?  'bg-white' : 'bg-gray-300'),
                        ('relative inline-flex flex-shrink-0 h-6 w-11 border-1 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 my-0 py-0'),
                        (ddAgreementError.value ? 'ring-1 ring-offset-1 ring-brand-primary' : 'focus:outline-none focus:ring-1 focus:ring-offset-1 focus:ring-brand-primary')
                        ])
                    }, {
                      default: _withCtx(() => [
                        _cache[57] || (_cache[57] = _createElementVNode("span", { class: "sr-only" }, "Use setting", -1)),
                        _createElementVNode("div", {
                          class: _normalizeClass([formData.formSelectionOptions.ddAgreementToggle ? 'translate-x-4 bg-brand-primary' : 'translate-x-0 bg-white', 'pointer-events-none relative inline-block h-5 w-5 rounded-full  shadow transform ring-0 transition ease-in-out duration-200 -ml-1'])
                        }, [
                          _createElementVNode("div", {
                            class: _normalizeClass([formData.formSelectionOptions.ddAgreementToggle ? 'opacity-0 ease-out duration-100' : 'opacity-100 ease-in duration-200', 'absolute inset-0 h-full w-full flex items-center justify-center transition']),
                            "aria-hidden": "true"
                          }, null, 2),
                          _createElementVNode("div", {
                            class: _normalizeClass([formData.formSelectionOptions.ddAgreementToggle ? 'opacity-100 ease-in duration-200' : 'opacity-0 ease-out duration-100', 'absolute inset-0 h-full w-full flex items-center justify-center transition']),
                            "aria-hidden": "true"
                          }, null, 2)
                        ], 2)
                      ]),
                      _: 1,
                      __: [57]
                    }, 8, ["modelValue", "class"])
                  ])
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["flex transition duration-200 justify-between items-center rounded-lg py-6 px-2 md:px-6", [formData.formSelectionOptions.privacyToggle ? 'bg-gradient-to-tr from-brand-primary-light to-brand-primary-dark text-white' : 'border-solid border-black border text-black']])
                }, [
                  _createElementVNode("div", _hoisted_49, [
                    _createTextVNode(" I consent to " + _toDisplayString(_unref(brandService).getTitle()) + " collecting, using, storing and disclosing my personal information in accordance with the " + _toDisplayString(_unref(brandService).getTitle()) + " Privacy Policy. I have read, understood and agree to comply with the " + _toDisplayString(_unref(brandService).getTitle()) + " ", 1),
                    _createElementVNode("a", {
                      href: `https://uniti-bpo-website-assets.assets.unitiinternet.com/${_unref(brandService).getName()}/privacy-policy.pdf`,
                      target: "_blank",
                      class: "underline transition duration-250 font-bold text-black"
                    }, "Privacy Policy", 8, _hoisted_50),
                    _cache[58] || (_cache[58] = _createTextVNode(". "))
                  ]),
                  _createElementVNode("div", _hoisted_51, [
                    _createVNode(_unref(Switch), {
                      onClick: handleClickPrivacyAgreement,
                      modelValue: formData.formSelectionOptions.privacyToggle,
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((formData.formSelectionOptions.privacyToggle) = $event)),
                      class: _normalizeClass([
                        (formData.formSelectionOptions.privacyToggle ?  'bg-white' : 'bg-gray-300'),
                        ('relative inline-flex flex-shrink-0 h-6 w-11 border-1 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 my-0 py-0'),
                        (privacyError.value ? 'ring-1 ring-offset-1 ring-brand-primary' : 'focus:outline-none focus:ring-1 focus:ring-offset-1 focus:ring-brand-primary')
                        ])
                    }, {
                      default: _withCtx(() => [
                        _cache[59] || (_cache[59] = _createElementVNode("span", { class: "sr-only" }, "Use setting", -1)),
                        _createElementVNode("div", {
                          class: _normalizeClass([formData.formSelectionOptions.privacyToggle ? 'translate-x-4 bg-brand-primary' : 'translate-x-0 bg-white', 'pointer-events-none relative inline-block h-5 w-5 rounded-full  shadow transform ring-0 transition ease-in-out duration-200 -ml-1'])
                        }, [
                          _createElementVNode("div", {
                            class: _normalizeClass([formData.formSelectionOptions.privacyToggle ? 'opacity-0 ease-out duration-100' : 'opacity-100 ease-in duration-200', 'absolute inset-0 h-full w-full flex items-center justify-center transition']),
                            "aria-hidden": "true"
                          }, null, 2),
                          _createElementVNode("div", {
                            class: _normalizeClass([formData.formSelectionOptions.privacyToggle ? 'opacity-100 ease-in duration-200' : 'opacity-0 ease-out duration-100', 'absolute inset-0 h-full w-full flex items-center justify-center transition']),
                            "aria-hidden": "true"
                          }, null, 2)
                        ], 2)
                      ]),
                      _: 1,
                      __: [59]
                    }, 8, ["modelValue", "class"])
                  ])
                ], 2)
              ])
            ])
          ])
        ])
      ]),
      _cache[92] || (_cache[92] = _createElementVNode("div", { class: "my-6 md:my-12" }, [
        _createElementVNode("hr")
      ], -1)),
      _createElementVNode("div", _hoisted_52, [
        _cache[61] || (_cache[61] = _createStaticVNode("<div class=\"text-left col-start-1 col-span-2 flex flex-col\" data-v-36535d2c><p class=\"font-benzin text-black text-2xl tracking-normal font-normal py-0 my-0\" data-v-36535d2c>CHOOSE YOUR<span class=\"text-brand-primary\" data-v-36535d2c> PAYMENT METHOD</span></p><p class=\"text-lg text-black font-poppins tracking-normal pt-2 py-0 my-0\" data-v-36535d2c>Enter your payment details to purchase your internet service</p><p class=\"text-base text-black font-bold font-poppins tracking-tight pt-4 py-0 my-0\" data-v-36535d2c>Pre-Authorisation Charge</p><p class=\"text-sm text-black font-poppins tracking-tight pt-0 py-0 my-0\" data-v-36535d2c>This $0.10 charge is a pre-authorisation to check that sufficient funds are available. <br data-v-36535d2c>The charge is cancelled once this is verified. This will be refunded back to your account within 7 business days.</p><p class=\"text-base text-black font-bold font-poppins tracking-tight pt-4 py-0 my-0\" data-v-36535d2c> Additional Processing Fees </p><p class=\"text-sm text-black font-poppins tracking-tight py-0 my-0\" data-v-36535d2c> Visa/Mastercard – 0.95% per transaction </p><p class=\"text-sm text-black font-poppins tracking-tight my-0\" data-v-36535d2c> AMEX – 2.4% per transaction </p><p class=\"text-sm text-black font-poppins tracking-tight my-0\" data-v-36535d2c> Bank direct debit – $0.1364 per transaction </p></div>", 1)),
        _createElementVNode("div", _hoisted_53, [
          _createVNode(StepGuide, { "current-step": 6 })
        ])
      ]),
      _createElementVNode("div", _hoisted_54, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_55, [
            _cache[73] || (_cache[73] = _createElementVNode("label", {
              for: "paymentMethodOptions",
              class: "text-2xl font-poppins-bold text-black"
            }, "Choose your payment method", -1)),
            _withDirectives(_createElementVNode("select", {
              id: "paymentMethodOptions",
              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((formData.formSelectionOptions.paymentMethod) = $event)),
              class: "block mt-2 font-poppins w-full rounded-full shadow-sm sm:text-sm bg-gray-200 border-none",
              onChange: handleActivationDate
            }, _cache[62] || (_cache[62] = [
              _createElementVNode("option", { value: 'cc' }, "Credit Card", -1),
              _createElementVNode("option", { value: 'dd' }, "Bank Account", -1)
            ]), 544), [
              [_vModelSelect, formData.formSelectionOptions.paymentMethod]
            ]),
            _cache[74] || (_cache[74] = _createElementVNode("h2", { class: "text-2xl font-poppins-bold text-black" }, "Enter your Details", -1)),
            (!directDebitFormFields.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                  _createElementVNode("div", _hoisted_57, [
                    _cache[63] || (_cache[63] = _createElementVNode("label", {
                      for: "card-number",
                      class: "block text-sm font-bold text-black"
                    }, "Card number", -1)),
                    _createElementVNode("div", _hoisted_58, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        id: "card-number",
                        name: "card-number",
                        autocomplete: "cc-number",
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((formData.ccNumber) = $event)),
                        onBlur: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_unref(v$).ccNumber.$touch && _unref(v$).ccNumber.$touch(...args))),
                        class: "block w-full rounded-full shadow-sm sm:text-sm bg-gray-200 border-none"
                      }, null, 544), [
                        [_vModelText, formData.ccNumber]
                      ])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).$errors, (error) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: error.$uid,
                        class: "mt-2 text-sm text-red-600",
                        id: "ccNumber-error"
                      }, [
                        (error.$property === 'ccNumber')
                          ? (_openBlock(), _createElementBlock("p", _hoisted_59, _toDisplayString(error.$message), 1))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_60, [
                    _cache[64] || (_cache[64] = _createElementVNode("label", {
                      for: "name-on-card",
                      class: "block text-sm font-bold text-black"
                    }, "Name on card", -1)),
                    _createElementVNode("div", _hoisted_61, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        id: "name-on-card",
                        name: "name-on-card",
                        autocomplete: "cc-name",
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((formData.ccName) = $event)),
                        onBlur: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_unref(v$).ccName.$touch && _unref(v$).ccName.$touch(...args))),
                        class: "block w-full rounded-full shadow-sm sm:text-sm bg-gray-200 border-none"
                      }, null, 544), [
                        [_vModelText, formData.ccName]
                      ])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).$errors, (error) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: error.$uid,
                        class: "mt-2 text-sm text-red-600",
                        id: "ccName-error"
                      }, [
                        (error.$property === 'ccName')
                          ? (_openBlock(), _createElementBlock("p", _hoisted_62, _toDisplayString(error.$message), 1))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_63, [
                    _cache[65] || (_cache[65] = _createElementVNode("label", {
                      for: "expiration-date",
                      class: "block text-sm font-bold text-black"
                    }, "Expiration date (MM/YY)", -1)),
                    _createElementVNode("div", _hoisted_64, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        name: "expiration-date",
                        id: "expiration-date",
                        autocomplete: "cc-exp",
                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((formData.ccExpiry) = $event)),
                        onBlur: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_unref(v$).ccExpiry.$touch && _unref(v$).ccExpiry.$touch(...args))),
                        class: "block w-full rounded-full shadow-sm sm:text-sm bg-gray-200 border-none"
                      }, null, 544), [
                        [_vModelText, formData.ccExpiry]
                      ])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).$errors, (error) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: error.$uid,
                        class: "mt-2 text-sm text-red-600",
                        id: "ccExpiry-error"
                      }, [
                        (error.$property === 'ccExpiry')
                          ? (_openBlock(), _createElementBlock("p", _hoisted_65, _toDisplayString(error.$message), 1))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("div", null, [
                    _cache[66] || (_cache[66] = _createElementVNode("label", {
                      for: "cvc",
                      class: "block text-sm font-bold text-black"
                    }, "CVC", -1)),
                    _createElementVNode("div", _hoisted_66, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        name: "cvc",
                        id: "cvc",
                        autocomplete: "cc-csc",
                        "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((formData.ccCvc) = $event)),
                        onBlur: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_unref(v$).ccCvc.$touch && _unref(v$).ccCvc.$touch(...args))),
                        class: "block w-full rounded-full shadow-sm sm:text-sm bg-gray-200 border-none"
                      }, null, 544), [
                        [_vModelText, formData.ccCvc]
                      ])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).$errors, (error) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: error.$uid,
                        class: "mt-2 text-sm text-red-600",
                        id: "ccCvc-error"
                      }, [
                        (error.$property === 'ccCvc')
                          ? (_openBlock(), _createElementBlock("p", _hoisted_67, _toDisplayString(error.$message), 1))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            (directDebitFormFields.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                  _createElementVNode("div", _hoisted_69, [
                    _cache[67] || (_cache[67] = _createElementVNode("label", {
                      for: "account-name",
                      class: "block text-sm font-bold text-black"
                    }, "Account Name", -1)),
                    _createElementVNode("div", _hoisted_70, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        name: "account-name",
                        id: "account-number",
                        "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((formData.ddAccountName) = $event)),
                        onBlur: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_unref(v$).ddAccountName.$touch && _unref(v$).ddAccountName.$touch(...args))),
                        class: "block w-full rounded-full shadow-sm sm:text-sm bg-gray-200 border-none"
                      }, null, 544), [
                        [_vModelText, formData.ddAccountName]
                      ])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).$errors, (error) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: error.$uid,
                        class: "mt-2 text-sm text-red-600",
                        id: "ddAccountName-error"
                      }, [
                        (error.$property === 'ddAccountName')
                          ? (_openBlock(), _createElementBlock("p", _hoisted_71, _toDisplayString(error.$message), 1))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_72, [
                    _cache[68] || (_cache[68] = _createElementVNode("label", {
                      for: "account-number",
                      class: "block text-sm font-bold text-black"
                    }, "Account Number", -1)),
                    _createElementVNode("div", _hoisted_73, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        name: "account-number",
                        id: "account-number",
                        "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((formData.ddAccountNumber) = $event)),
                        onBlur: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => (_unref(v$).ddAccountNumber.$touch && _unref(v$).ddAccountNumber.$touch(...args))),
                        class: "block w-full rounded-full shadow-sm sm:text-sm bg-gray-200 border-none"
                      }, null, 544), [
                        [_vModelText, formData.ddAccountNumber]
                      ])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).$errors, (error) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: error.$uid,
                        class: "mt-2 text-sm text-red-600",
                        id: "ddAccountNumber-error"
                      }, [
                        (error.$property === 'ddAccountNumber')
                          ? (_openBlock(), _createElementBlock("p", _hoisted_74, _toDisplayString(error.$message), 1))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("div", null, [
                    _cache[69] || (_cache[69] = _createElementVNode("label", {
                      for: "bsb",
                      class: "block text-sm font-bold text-black"
                    }, "BSB", -1)),
                    _createElementVNode("div", _hoisted_75, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        name: "bsb",
                        id: "bsb",
                        "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((formData.ddAccountBsb) = $event)),
                        onBlur: _cache[32] || (_cache[32] = 
//@ts-ignore
(...args) => (_unref(v$).ddAccountBsb.$touch && _unref(v$).ddAccountBsb.$touch(...args))),
                        class: "block w-full rounded-full shadow-sm sm:text-sm bg-gray-200 border-none"
                      }, null, 544), [
                        [_vModelText, formData.ddAccountBsb]
                      ])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).$errors, (error) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: error.$uid,
                        class: "mt-2 text-sm text-red-600",
                        id: "ddAccountBsb-error"
                      }, [
                        (error.$property === 'ddAccountBsb')
                          ? (_openBlock(), _createElementBlock("p", _hoisted_76, _toDisplayString(error.$message), 1))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            (_unref(orderService).calculateMinimumCost(_ctx.products, isPromoValid.value, _ctx.validPromotion) >= 1000)
              ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                  _cache[70] || (_cache[70] = _createElementVNode("p", { class: "text-sm text-black font-poppins tracking-tight pt-0 py-0 my-0" }, "Based on the total value of your order, and in accordance with our obligations under the 2019 TCP Code, Nexee is required to run an external credit check before we can confirm your order. This may delay your service activation as it is dependent on the credit check being completed first.", -1)),
                  _cache[71] || (_cache[71] = _createElementVNode("label", {
                    for: "birthdate",
                    class: "block text-sm font-bold text-black font-poppins pt-4"
                  }, "Birthdate", -1)),
                  _createElementVNode("div", _hoisted_78, [
                    _withDirectives(_createElementVNode("input", {
                      type: "date",
                      max: min18.value,
                      name: "birthdate",
                      id: "birthdate",
                      "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((formData.birthdate) = $event)),
                      onBlur: _cache[34] || (_cache[34] = 
//@ts-ignore
(...args) => (_unref(v$).birthdate.$touch && _unref(v$).birthdate.$touch(...args))),
                      class: "block w-full rounded-full shadow-sm sm:text-sm bg-gray-200 border-none"
                    }, null, 40, _hoisted_79), [
                      [_vModelText, formData.birthdate]
                    ])
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).$errors, (error) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: error.$uid,
                      class: "mt-2 text-sm text-red-600",
                      id: "bday-error"
                    }, [
                      (error.$property === 'birthdate')
                        ? (_openBlock(), _createElementBlock("p", _hoisted_80, _toDisplayString(error.$message), 1))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_unref(orderService).calculateMinimumCost(_ctx.products, isPromoValid.value, _ctx.validPromotion) >= 1000)
              ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                  _cache[72] || (_cache[72] = _createElementVNode("label", {
                    for: "License Id",
                    class: "block text-sm font-bold text-black font-poppins"
                  }, "License Id", -1)),
                  _createElementVNode("div", _hoisted_82, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      id: "licenseId",
                      name: "licenseId",
                      autocomplete: "licenseId",
                      "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((formData.licenseId) = $event)),
                      class: "block w-full rounded-full shadow-sm sm:text-sm bg-gray-200 border-none"
                    }, null, 512), [
                      [_vModelText, formData.licenseId]
                    ])
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).$errors, (error) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: error.$uid,
                      class: "mt-2 text-sm text-red-600",
                      id: "licenseid-error"
                    }, [
                      (error.$property === 'licenseId')
                        ? (_openBlock(), _createElementBlock("p", _hoisted_83, _toDisplayString(error.$message), 1))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_84, [
          _cache[90] || (_cache[90] = _createElementVNode("h2", { class: "text-2xl font-poppins-bold text-black" }, "Order Summary", -1)),
          _createElementVNode("div", _hoisted_85, [
            _cache[89] || (_cache[89] = _createElementVNode("h3", { class: "sr-only" }, "Items in your cart", -1)),
            _createElementVNode("div", _hoisted_86, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (product) => {
                return _withDirectives((_openBlock(), _createElementBlock("div", {
                  key: product.name,
                  class: "flex py-4 px-4 sm:px-6 border rounded-lg border-solid border-black text-black"
                }, [
                  _createElementVNode("div", _hoisted_87, [
                    _createElementVNode("div", _hoisted_88, [
                      _createElementVNode("h4", _hoisted_89, [
                        _withDirectives(_createElementVNode("span", _hoisted_90, "Plan: ", 512), [
                          [_vShow, product.type === 'internet']
                        ]),
                        _withDirectives(_createElementVNode("span", _hoisted_91, "VoIP: ", 512), [
                          [_vShow, product.type === 'voice']
                        ]),
                        _withDirectives(_createElementVNode("span", _hoisted_92, "Router: ", 512), [
                          [_vShow, product.type === 'hardware']
                        ]),
                        _createTextVNode(" " + _toDisplayString(product.name), 1)
                      ]),
                      _createElementVNode("p", _hoisted_93, _toDisplayString(product.description), 1),
                      _withDirectives(_createElementVNode("span", _hoisted_94, " Unlimited data ", 512), [
                        [_vShow, product.type === 'internet']
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_95, [
                    _createElementVNode("div", _hoisted_96, [
                      _createElementVNode("p", {
                        class: _normalizeClass(["my-0 py-0 font-poppins-bold", ['text-md', isPromoValid.value && product.discounted ? 'text-decoration-line: line-through text-gray-300' : 'text-gray-900']])
                      }, _toDisplayString(_unref(utilityService).formatCurrency(product.price)), 3)
                    ]),
                    _createElementVNode("div", _hoisted_97, [
                      (product.type !== 'hardware')
                        ? (_openBlock(), _createElementBlock("p", _hoisted_98, " Monthly "))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_99, [
                      (isPromoValid.value && product.discounted)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_100, _toDisplayString(_unref(utilityService).formatCurrency(product.discountedPrice ?? 0)), 1))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])), [
                  [_vShow, product.type === 'internet' || product.type === 'voice' || product.type === 'hardware']
                ])
              }), 128))
            ]),
            _createElementVNode("dl", _hoisted_101, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (product) => {
                return _withDirectives((_openBlock(), _createElementBlock("div", {
                  key: product.name,
                  class: "flex items-center justify-between border rounded-lg border-solid border-black text-black px-6"
                }, [
                  _cache[75] || (_cache[75] = _createElementVNode("dt", { class: "text-md font-poppins-bold py-6" }, " Activation Fee ", -1)),
                  _createElementVNode("div", _hoisted_102, [
                    _createElementVNode("div", _hoisted_103, [
                      (product.price >= 0 && !isPromoValid.value || !product.displayDiscount)
                        ? (_openBlock(), _createElementBlock("dd", {
                            key: 0,
                            class: _normalizeClass(['text-md font-poppins-bold', isPromoValid.value && product.displayDiscount ? 'text-decoration-line: line-through text-gray-300' : 'text-gray-900'])
                          }, _toDisplayString(_unref(utilityService).formatCurrency(product.price)), 3))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_104, [
                      (isPromoValid.value && product.discounted)
                        ? (_openBlock(), _createElementBlock("dd", _hoisted_105, _toDisplayString(_unref(utilityService).formatCurrency(product.discountedPrice ?? 0)), 1))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])), [
                  [_vShow, product.code === 'ACTIVATION-FEE']
                ])
              }), 128)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (product) => {
                return _withDirectives((_openBlock(), _createElementBlock("div", {
                  key: product.name,
                  class: "flex items-center justify-between py-4 px-4 sm:px-6 border rounded-lg border-solid border-black text-black my-4"
                }, [
                  _createElementVNode("dt", _hoisted_106, [
                    _cache[77] || (_cache[77] = _createTextVNode(" New Development Fee ")),
                    _createElementVNode("div", _hoisted_107, [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(InformationCircleIcon)), {
                        class: "h-6 w-6 text-brand-button-text",
                        "aria-hidden": "true"
                      })),
                      _cache[76] || (_cache[76] = _createElementVNode("span", { class: "tooltiptext" }, [
                        _createElementVNode("p", { class: "tooltipmsg" }, "The New Development Charge or NDC is a charge that is passed on from the network wholesale provider to residents via the Retail Service Provider. This fee is applied to all new developments as a one-time fee for the first user to activate an internet service.")
                      ], -1))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_108, [
                    _createElementVNode("div", _hoisted_109, [
                      _createElementVNode("dd", {
                        class: _normalizeClass(['text-sm font-medium', isPromoValid.value && product.displayDiscount ? 'text-decoration-line: line-through text-gray-300' : 'text-gray-900'])
                      }, _toDisplayString(_unref(utilityService).formatCurrency(product.price)), 3)
                    ]),
                    _createElementVNode("div", _hoisted_110, [
                      (isPromoValid.value && product.discounted)
                        ? (_openBlock(), _createElementBlock("dd", _hoisted_111, _toDisplayString(_unref(utilityService).formatCurrency(product.discountedPrice ?? 0)), 1))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])), [
                  [_vShow, product.code === 'NDC']
                ])
              }), 128)),
              _createElementVNode("div", _hoisted_112, [
                _cache[79] || (_cache[79] = _createElementVNode("h2", { class: "text-lg font-poppins-bold my-0 py-0" }, "Promotions", -1)),
                _cache[80] || (_cache[80] = _createElementVNode("h3", { class: "sr-only" }, "Enter promotion code here", -1)),
                _createElementVNode("div", _hoisted_113, [
                  _cache[78] || (_cache[78] = _createElementVNode("label", {
                    for: "promoCode",
                    class: "block text-md font-medium text-black pb-1"
                  }, "Do you have a promotion code?", -1)),
                  _createElementVNode("div", _hoisted_114, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      name: "promoCode",
                      id: "promoCode",
                      autocomplete: "off",
                      "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((promoCode).value = $event)),
                      onBlur: _cache[37] || (_cache[37] = 
//@ts-ignore
(...args) => (_unref(v$).ddAccountBsb.$touch && _unref(v$).ddAccountBsb.$touch(...args))),
                      class: "uppercase block w-full rounded-full shadow-sm sm:text-sm bg-gray-200 border-none max-w-md text-lg font-poppins font-bold px-6"
                    }, null, 544), [
                      [_vModelText, promoCode.value]
                    ]),
                    _createElementVNode("button", {
                      onClick: promoCodeClickHandler,
                      type: "button",
                      class: "cursor-pointer items-center ml-2 px-4 py-2 border border-black border-solid shadow-sm text-sm md:text-lg font-poppins rounded-full text-black bg-white hover:bg-black hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-accent"
                    }, "Apply Code")
                  ]),
                  (isPromoValid.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_115, "Promo code " + _toDisplayString(_ctx.validPromotion?.code) + " applied!", 1))
                    : _createCommentVNode("", true),
                  (!isPromoValid.value && promoCode.value && promoCode.value.length > 0)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_116, "Promo code invalid!"))
                    : _createCommentVNode("", true)
                ])
              ]),
              (isPromoValid.value && promoCode.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_117, [
                    _cache[85] || (_cache[85] = _createElementVNode("h2", { class: "text-lg font-poppins-bold my-0 py-0" }, "Promotion includes:", -1)),
                    (delayedNdc.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_118, _cache[81] || (_cache[81] = [
                          _createElementVNode("dt", { class: "text-sm font-extralight" }, " • The new development fee of $300 will be applied in month 13 ", -1)
                        ])))
                      : _createCommentVNode("", true),
                    (yearOff.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_119, _cache[82] || (_cache[82] = [
                          _createElementVNode("dt", { class: "text-sm font-extralight" }, " • First Year Free! - Standard billing will commence in month 13 ", -1)
                        ])))
                      : _createCommentVNode("", true),
                    (monthOff.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_120, _cache[83] || (_cache[83] = [
                          _createElementVNode("dt", { class: "text-sm font-extralight" }, " • First Month Free! ", -1)
                        ])))
                      : _createCommentVNode("", true),
                    (preInstalledRouter.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_121, _cache[84] || (_cache[84] = [
                          _createElementVNode("dt", { class: "text-sm font-extralight" }, " • Pre-Installed router ", -1)
                        ])))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_122, [
                _createElementVNode("div", _hoisted_123, [
                  _cache[87] || (_cache[87] = _createTextVNode(" First Invoice Total ")),
                  _createElementVNode("dt", _hoisted_124, [
                    _cache[86] || (_cache[86] = _createTextVNode(" The total minimum cost of service over duration of the contract selected less any discounts is ")),
                    _createElementVNode("span", _hoisted_125, _toDisplayString(_unref(utilityService).formatCurrency(_unref(orderService).calculateMinimumCost(_ctx.products, isPromoValid.value, _ctx.validPromotion))), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_126, _toDisplayString(_unref(utilityService).formatCurrency(_unref(orderService).calculateFirstInvoiceTotal(_ctx.products, isPromoValid.value, _ctx.validPromotion))), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_127, [
              _createVNode(AsyncButton, {
                onOnClick: handleConfirmOrder,
                class: "w-full"
              }, {
                default: _withCtx(() => _cache[88] || (_cache[88] = [
                  _createTextVNode("Confirm Order")
                ])),
                _: 1,
                __: [88]
              }),
              _createElementVNode("div", _hoisted_128, [
                (confirmAddressError.value || termsAgreementError.value || ddAgreementError.value || csgWaiverError.value || privacyError.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_129, " Please confirm your details and tick the required fields "))
                  : _createCommentVNode("", true),
                (_unref(v$).$error)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_130, " Please fill out all required form fields "))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (error) => {
                  return (_openBlock(), _createElementBlock("p", {
                    key: error,
                    class: "mt-4 text-sm text-red-600"
                  }, _toDisplayString(error), 1))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})